import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { GroundType, ProjectSettingsStore } from '../../stores/ProjectSettingsStore';
import { VisibilityStore } from '../../stores/VisibilityStore';
import { PopupMenu, SidebarModule } from '../../constants/Enums';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { SelectBoxOption } from '../../stores/SelectBoxStore';
import { ProjectSettingsActions } from '../../actions/ProjectSettingsActions';
import { UIHelper } from '../../utils/UIHelper';
import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { GlobalHelper } from '../../utils/GlobalHelper';
import { DialogActions } from '../../actions/DialogActions';
import { PopupFlagPosition } from '../../constants/PopupFlagPositions';
import { CoreTooltip } from '../CoreTooltip';
import { BasePopupMenu } from './BasePopupMenu';

interface GroundSetupProps extends React.Props<GroundSetup> {
    layoutType: LayoutType;
}

interface GroundSetupState {
    groundType: GroundType | 'floorplan';
    open: boolean;
}

export class GroundSetup extends BaseComponent<GroundSetupProps, GroundSetupState> {
    public componentWillMount(): void {
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.addStoreListener(VisibilityStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        return (
            <BasePopupMenu
                defaultValue={this.state.groundType}
                flagPosition={this.props.layoutType === LayoutType.SMALL ? PopupFlagPosition.TOPRIGHT : PopupFlagPosition.TOPLEFT}
                open={this.state.open}
                toggleCallback={this.toggleSelect}
                className="toolbar-button sprite-icon-config toolbar-button-popup"
                options={this.options()}
                title={{label: t('Workspace'), className: ''}}
            >
                {this.state.open ? null : <CoreTooltip config={{label: t('Workspace')}}/>}
            </BasePopupMenu>
        );
    }

    protected onChange = (): void => {
        this.setState({
            groundType: ProjectSettingsStore.getFloorPlanVisibility() ? 'floorplan' : (ProjectSettingsStore.getState().groundType || 'solid'),
            open: VisibilityStore.getState().popupMenu === PopupMenu.GROUND_SETUP
        });
    };

    protected toggleSelect = (showPopup: boolean) => {
        if (!showPopup) {
            ViewSettingsActions.changeSidebar(SidebarModule.NONE);
            VisibilityActions.setPopupMenu(PopupMenu.GROUND_SETUP);
        } else {
            VisibilityActions.hidePopupMenu(PopupMenu.GROUND_SETUP);
        }
    };

    protected options = (): Array<SelectBoxOption> => {
        const floorplanHasTexture: boolean = GlobalHelper.floorPlan == null || !GlobalHelper.floorPlan.hasTexture();
        return [
            {
                name: t('Invisible', {context: 'button-label (first letter upper case)'}),
                value: 'nofloor',
                className: 'egr-select-option-noicon',
                callback: () => { ProjectSettingsActions.setGroundType('nofloor'); }
            },
            {
                name: t('Color'),
                value: 'solid',
                className: 'egr-select-option-has-extrabutton',
                callback: () => { ProjectSettingsActions.setGroundType('solid'); },
                extraButtons: [<div key="color-extra" className="egr-select-extrabutton sprite-icon-pen" onClick={this.setupSolid}/>]
            },
            {
                name: t('Floor Plan'),
                value: 'floorplan',
                className: 'egr-select-option-has-extrabutton',
                callback: DialogActions.triggerFloorPlanUpload,
                hidden: !AppConfigurationStore.getState().floorplanAvailable || !floorplanHasTexture,
                extraButtons: [<div key="sprite-icon-upload" className="egr-select-extrabutton sprite-icon-upload"/>]
            },
            {
                name: t('Floor Plan'),
                value: 'floorplan',
                className: 'egr-select-option-has-extrabutton',
                callback: ProjectSettingsActions.showFloorPlan,
                hidden: !AppConfigurationStore.getState().floorplanAvailable || floorplanHasTexture,
                extraButtons: [<div key="floorplan-extra" className="egr-select-extrabutton sprite-icon-pen" onClick={this.setupFloorplan}/>]
            }
        ];
    };

    protected setupSolid = (event: React.MouseEvent<HTMLElement>): void => {
        UIHelper.stopEvent(event);
        ProjectSettingsActions.setGroundType('solid');
        VisibilityActions.setPopupMenu(PopupMenu.SOLIDFLOOR_SETUP);
    };

    protected setupFloorplan = (event: React.MouseEvent<HTMLElement>): void => {
        UIHelper.stopEvent(event);
        ProjectSettingsActions.showFloorPlan();
        VisibilityActions.setPopupMenu(PopupMenu.FLOORPLAN_SETUP);
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/GroundSetup.tsx